import React, { useState } from 'react';
import {
  Grid,
  Typography,
  Link,
  Tooltip,
} from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
import { makeStyles } from '@material-ui/core/styles';
import commonStyles from '../../styles';
import MemberStatusCode from '../../eleCommon/memberStatusCode';
import { URL_MAPPER } from '../../../constants/urls';
import { GUIDANCE_STATUS_CODE } from '../../../constants';

const useStyles = makeStyles((theme) => ({
  bodyCustomerContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    overflow: 'hidden',
    '& .material-icons': {
      color: theme.palette.primaryColor,
      fontSize: 16,
      marginRight: 5,
      flexShrink: 0,
    },
  },
  bodyCustomerNameTxt: {
    color: theme.palette.primaryColor,
    fontSize: 13,
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
  },
  ratingIcon: {
    margin: '0 10px',
    '& span': {
      fontSize: 18,
      marginRight: 0,
    },
  },
  memberStatus: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& svg': {
      width: 18.33,
      height: 18.33,
    },
  },
  gridContainer: {
    flexWrap: 'nowrap',
    width: '100%',
    display: 'flex',
  },
  nameItem: {
    minWidth: 0,
    flexBasis: '40%',
    flexShrink: 1,
  },
  statusItem: {
    flexGrow: 1,
    textAlign: 'center',
    padding: '0 8px',
    minWidth: 0,
  },
  iconItem: {
    flexShrink: 0,
    textAlign: 'right',
  },
}));

function LineReceptionCustomer(props) {
  const {
    id,
    memberId,
    fullName = '',
    memberStatus,
    customerStatus,
    children,
  } = props;

  const classes = useStyles();
  const baseClasses = commonStyles();
  const [open, setOpen] = useState(false);

  const onOpen = () => {
    const targets = document.getElementsByClassName('dashbordScrollArea');
    for (let i = 0; i < targets.length; i += 1) {
      const el = targets[i];
      el.addEventListener('scroll', () => { setOpen(false); }, { once: true });
    }
  };
  return (
    <Grid
      container
      alignItems="center"
      className={classes.gridContainer}
    >
      <Grid item className={classes.nameItem}>
        <Link href={`${URL_MAPPER.customer}?customerId=${id}`} target="_blank" className={classes.bodyCustomerContainer}>
          <Icon className="material-icons-outlined">summarize</Icon>
          <Tooltip title={fullName} onOpen={onOpen} open={open}>
            <Typography
              noWrap
              className={`${classes.bodyCustomerNameTxt} ${baseClasses.smallStrong}`}
              onMouseOver={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}
            >
              {fullName}
            </Typography>
          </Tooltip>
        </Link>
      </Grid>
      <Grid item className={classes.statusItem}>
        <Typography style={{ fontSize: 13, textAlign: 'center' }} className="nowrap">
          {customerStatus || '-'}
        </Typography>
      </Grid>
      <Grid item className={classes.iconItem}>
        <div className={classes.memberStatus}>
          {memberStatus === null ? (
            <MemberStatusCode code={memberStatus} />
          ) : (
            <Link href={`${URL_MAPPER.web}?memberId=${memberId}`} target="_blank">
              <MemberStatusCode code={memberStatus} />
            </Link>
          )}
          {children}
        </div>
      </Grid>
    </Grid>
  );
}

export default LineReceptionCustomer;

export const createGuidanceStatusText = (data) => {
  const arr = [];
  // 案内ステータスコード
  if (data.guidanceStatusCode) {
    arr.push(GUIDANCE_STATUS_CODE[data.guidanceStatusCode]);
  }
  if (data.isPairCheck) arr.push('揃い');
  if (data.isFp) arr.push('FP');
  return arr.join('/');
};
